import { computed, effect, inject, Injectable, signal } from "@angular/core";
import { basicUserInfo } from "../models/login.model";
import { SessionStorageService } from "../services/session-storage.service";
import { Router } from "@angular/router";

@Injectable({
    providedIn:'root'
})
export class UserInfoStore{
    private storage=inject(SessionStorageService);
    private readonly STORAGE_KEY='user_info';
  private userinfo=signal<basicUserInfo | null>(this.loadStateFromStorage());
  readonly userinfo_=computed(()=> this.userinfo());
  private router=inject(Router);

  // private _email=signal(this.userinfo()?.email ?? '');
  // private _name=signal(this.userinfo()?.name ?? '');
  // private _role=signal(this.userinfo()?.NeuraRole ?? '');
  // private _userId=signal(this.userinfo()?.userId ?? -1);
  // private _initials=signal(this.userinfo()?.initials ?? '');
  // private _profileColor=signal(this.userinfo()?.profileColor ?? '');


  readonly email=computed(()=> this.userinfo()?.email ?? '');
  readonly name=computed(()=> this.userinfo()?.name ?? '');
  readonly role=computed(()=> this.userinfo()?.NeuraRole ?? '');
  readonly userId=computed(()=> this.userinfo()?.userId ?? -1);
  readonly initials=computed(()=> this.userinfo()?.initials ?? '');
  readonly profileColor=computed(()=> this.userinfo()?.profileColor ?? '');



  constructor(){
    effect(()=>{
      const value=this.userinfo();
      if(value){
        localStorage.setItem(this.STORAGE_KEY,JSON.stringify(value));
      }else{
        localStorage.removeItem(this.STORAGE_KEY)
      }
    })
  }

  setUserInfo(info:basicUserInfo){
    this.userinfo.set(info);
    this.storage.set(this.STORAGE_KEY,JSON.stringify(info));
  }

  updateUserInfo(partial:Partial<basicUserInfo>){
    this.userinfo.update((s)=> (s ? {...s,...partial}: s));
    this.storage.set(this.STORAGE_KEY,JSON.stringify(this.userinfo()));

  }
    logOut(){
    localStorage.clear();
    // this.dialog.closeAll();
    this.router.navigate(['/landing']);
  }

  clearSession(){
    this.userinfo.set(null);
  }

  private loadStateFromStorage(): basicUserInfo | null {

    try{
      const json=this.storage.get(this.STORAGE_KEY);
      return json ? JSON.parse(json) : null
    }catch{
      return null;
    }
  }
}